module.exports = __webpack_public_path__ + "./docs/img/big-icon-setter.58d76db487438c4c8ce108bb46b76928.svg";